import { useTypedSelector } from "../../../../store/reducers/use-typed-selector";
import { FeatureFlagsEnum } from "../../../../types/working-model";

export const useIsAudienceListsUiQ32023 = () => {
	const featureFlags = useTypedSelector(state => state.FeatureFlagsReducer.featureFlags);

	return !!featureFlags[FeatureFlagsEnum.audience_list_ui_q3_2023];
};